import { useJsonLd } from '../../lib/useJsonLd';

interface Props {
  faq: Array<{ q: string; a: string }>;
}

/**
 * Sekcja FAQ + schemat FAQPage (JSON-LD). Natywne <details> = zero JS, dostępne,
 * przyjazne Lighthouse. FAQPage to silny sygnal answer-first dla LLM (cytowalne Q&A).
 */
export default function NicheFaq({ faq }: Props) {
  useJsonLd('ld-faq', {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faq.map((f) => ({
      '@type': 'Question',
      name: f.q,
      acceptedAnswer: { '@type': 'Answer', text: f.a },
    })),
  });

  return (
    <section className="px-6 py-16 md:py-24 max-w-3xl mx-auto w-full">
      <div className="flex items-center gap-3 mb-8">
        <div className="w-8 h-px bg-stroke" />
        <span className="text-xs text-muted uppercase tracking-[0.3em]">Najczęstsze pytania</span>
      </div>
      <div className="space-y-4">
        {faq.map((f) => (
          <details key={f.q} className="group rounded-2xl border border-stroke bg-surface p-5">
            <summary className="cursor-pointer list-none font-medium text-text-primary flex items-center justify-between gap-4">
              {f.q}
              <span className="text-muted transition-transform group-open:rotate-45" aria-hidden="true">+</span>
            </summary>
            <p className="mt-3 text-muted leading-relaxed">{f.a}</p>
          </details>
        ))}
      </div>
    </section>
  );
}
